import { chargerDocument } from './api';

/**
 * Enregistre le document sur le poste. On ne l'ouvre PAS dans un onglet :
 * une URL blob hérite de l'origine de l'application, et un fichier reçu d'un
 * inconnu y exécuterait son propre script. Un téléchargement ne rend la main
 * qu'au système de fichiers.
 */
export async function telechargerDocument(documentId: string, nomFichier: string): Promise<void> {
  const lien = await chargerDocument(documentId);
  const ancre = window.document.createElement('a');
  ancre.href = lien;
  ancre.download = nomFichier;
  ancre.rel = 'noopener';
  window.document.body.append(ancre);
  ancre.click();
  ancre.remove();
  URL.revokeObjectURL(lien);
}
